import { render, staticRenderFns } from "./SavedAlert.vue?vue&type=template&id=2e59c96e&scoped=true&"
import script from "./SavedAlert.vue?vue&type=script&lang=js&"
export * from "./SavedAlert.vue?vue&type=script&lang=js&"
import style0 from "./SavedAlert.vue?vue&type=style&index=0&id=2e59c96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e59c96e",
  null
  
)

export default component.exports